import { FC, useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';

const StartingPrice: FC = () => {
  const { estate } = useContext(ObjectPageContext);

  return (
    <div className="flex flex-row gap-2 mb-2">
      <span className="header-info-item text-lg">
        Utgångspris:{' '}
        {estate?.priceInfo.startPrice
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
        kr
      </span>
    </div>
  );
};
export default StartingPrice;
